import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { Workplace } from '../../models/workplace';
import { FirebaseProvider } from '../firebase/firebase';

@Injectable()
export class WorkplaceProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  /**
   * Recuperar tots els llocs de treball (visibles i no visibles).
   */
  getAllWorkplaces(): Observable<Workplace[]> {
    return this.firebaseService.list(this.getBaseRoot());
  }

  getUserWorkplaces(userId?: string): Observable<Workplace[]> {
    return this.firebaseService.listOnce(tableNames.Repo + '/' + this.globalVars.user.repo + '/'
      + tableNames.User + '/' + (userId || this.globalVars.user.key) + '/' + tableNames.Workplace)
  }

  /**
   * Recuperar els llocs de treball.
   */
  getWorkplaces(): Observable<Workplace[]> {
    return this.firebaseService.list(this.getBaseRoot())
      .map(workplaces => workplaces.filter(workplace => workplace.visible != false));
  }

  /**
   * Recuperar els llocs de treball (només una vegada).
   */
  getWorkplacesOnce(): Observable<Workplace[]> {
    return this.firebaseService.listOnce(this.getBaseRoot())
      .map(workplaces => workplaces.filter(workplace => workplace.visible != false));
  }

  /**
   * Recuperar els llocs de treball que coincideixin amb les ID.
   * 
   * @param workplacesIds IDs dels centres de treball
   */
  getWorkplacesOnceById(workplacesIds: string[]): Observable<Workplace[]>  {
    return this.firebaseService.listOnce(this.getBaseRoot())
      .map(workplaces => workplaces
        .filter(workplace => workplace.visible != false && workplacesIds.indexOf(workplace.key) > -1));
  }
  
  /**
   * Eliminar un lloc de treball.
   * 
   * @param workplaceId ID del lloc de treball.
   */
  remove(workplaceId): Promise<void> {
    return this.firebaseService.remove(this.getBaseRoot(), workplaceId)
  }

  /**
   * Guardar un lloc de treball
   * 
   * @param workplace Lloc de treball a guardar.
   */
  save(workplace: Workplace): Promise<any> {
    if(workplace.key) {
      var key = workplace.key;
      delete workplace.key;
      return this.firebaseService.set(this.getBaseRoot(), key, workplace)
    }
      
    else return this.firebaseService.push(this.getBaseRoot(), workplace)
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Workplace;
  }

}



// WEBPACK FOOTER //
// ./src/providers/workplace/workplace.ts